import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/event-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlurFade"] */ "/app/src/components/ui/blur-fade.tsx");
